import { forwardRef } from "react";
import styles from "./Select.module.css";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
	options: { value: string; label: string }[];
	error?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
	({ options, className, error, ...props }, ref) => {
		return (
			<select
				ref={ref}
				className={[styles.select, error && styles.error, className].filter(Boolean).join(" ")}
				{...props}
			>
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</select>
		);
	},
);
Select.displayName = "Select";
